import {gsap} from "gsap";

export default class ModuleText {
	constructor(el) {
        this.el = el;

        this.footnotes = this.el.querySelectorAll('[data-footnote]');
        this.resizeObserver = new ResizeObserver(this.handleResize.bind(this));
        if(this.footnotes.length) {
            this.resizeObserver.observe(this.el);
        }
	}

	handleResize() {
        this.prevBottom = 0;

        this.footnotes.forEach(footnote => {
            gsap.set(footnote, {
                top: 0,
            });
        });

        setTimeout(() => {
            this.setFootnotePos();
        }, 0);
	}

    setFootnotePos() {
        this.footnotes.forEach(footnote => {
            const footnoteY = footnote.getBoundingClientRect().top - this.el.getBoundingClientRect().top;

            const footnoteID = footnote.getAttribute('data-footnote');
            const footnoteContentElm = this.el.querySelector('[data-footnote-content="'+footnoteID+'"');

            let targetTop = footnoteY;
            if(this.prevBottom>footnoteY) {
                targetTop = this.prevBottom + 10;
            }
            gsap.set(footnoteContentElm, {
                top: targetTop+'px',
                onComplete: () => {
                    this.prevBottom = (footnoteContentElm.getBoundingClientRect().top - this.el.getBoundingClientRect().top) + footnoteContentElm.getBoundingClientRect().height;
                }
            });

        });

        // Add extra margin to bottom of module when the footnotes exceed the limits of the module
        this.bottomOverflow = this.el.getBoundingClientRect().height-this.prevBottom;
        let moduleMarginBottom = 0;
        if(this.bottomOverflow<0) {
            moduleMarginBottom = (this.bottomOverflow-10)*-1;
        }
        gsap.set(this.el, {
            marginBottom: moduleMarginBottom+'px'
        });
    }

    destroy() {
        this.resizeObserver.disconnect();
    }
}